<template>
  <div class="explain">
    <div class="project-edit">
      <!-- 标题 -->
      <div class="page-title-box">
        <div class="page-back" @click="$router.go(-1)">返回</div>
        <div class="page-title">{{ getOption().name }}-变更日志</div>
      </div>

      <div class="basic-infor">
        <div class="import-title">
          <span class="sub-title">变更前信息</span>
        </div>
        <div class="customer-information explain-contain">
          <el-row>
            <el-col :span="12">
              <span class="explain-title">变更时间：</span>
              <span class="explain-content">{{ $route.query.createTime.slice(0, 19) }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">{{ getOption().typeName }}</span>
              <span class="explain-content">{{ getOption().type }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">{{ getOption().label }}</span>
              <span class="explain-content">{{ getOption().name }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">{{ getOption().label }}</span>
              <span class="explain-content">{{ getOption().name }}</span>
            </el-col>
            <el-col :span="12" v-if="objectType === '1'">
              <span class="explain-title">客户等级：</span>
              <span class="explain-content">{{ transform(getFieldConfig('level', 'selectItemList'), LogDetail.level) }}</span>
            </el-col>
            <!-- 医院资料 -->
            <HospitalOption v-else-if="objectType === '4'" :LogDetail="LogDetail"></HospitalOption>
            <el-col :span="12" v-if="objectType === '1'">
              <span class="explain-title">地图位置：</span>
              <span class="explain-content">{{ LogDetail.markingPosition }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">经纬度：</span>
              <span class="explain-content"
                >{{ LogDetail.lng }}<span v-show="LogDetail.lat">,{{ LogDetail.lat }}</span></span
              >
            </el-col>
            <el-col :span="12">
              <span class="explain-title">所在区域：</span>
              <span class="explain-content">{{ LogDetail.venue }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">详细地址：</span>
              <span class="explain-content">{{ LogDetail.address }}</span>
            </el-col>
            <el-col :span="12" v-show="LogDetail.terminalProperty == '连锁总部' && objectType === '1'">
              <span class="explain-title">直营门店数量（家）：</span>
              <span class="explain-content">{{ LogDetail.directStoresNum }}</span>
            </el-col>
            <el-col :span="12" v-show="LogDetail.terminalProperty == '连锁总部' && objectType === '1'">
              <span class="explain-title">加盟门店数量（家）：</span>
              <span class="explain-content">{{ LogDetail.affiliatedShopNum }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">联系人：</span>
              <span class="explain-content">{{ LogDetail.contacts || '-' }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">手机号码：</span>
              <span class="explain-content">{{ LogDetail.contactTel || '-' }}</span>
            </el-col>
            <el-col :span="12" v-show="LogDetail.terminalProperty !== '连锁总部' && objectType === '1'">
              <span class="explain-title">经营时长：</span>
              <span class="explain-content">{{ LogDetail.manageDuration || '-' }}</span>
            </el-col>
            <el-col :span="12" v-show="LogDetail.terminalProperty !== '连锁总部' && objectType === '1'">
              <span class="explain-title">面积(m2)：</span>
              <span class="explain-content">{{ LogDetail.areaMeasure || '-' }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">建档时间：</span>
              <span class="explain-content">{{ LogDetail.inputDate | getDate }}</span>
            </el-col>
            <el-col :span="12">
              <span class="explain-title">负责人员：</span>
              <span class="explain-content">{{ LogDetail.maintainStaff && LogDetail.maintainStaff.staffName ? `${LogDetail.maintainStaff.staffName}-${LogDetail.maintainStaff.mobileNo}` : '-' }}</span>
            </el-col>
            
            
          </el-row>
          <el-row>
            <el-col :span="24">
              <span class="explain-title">业务指派人员：</span>
              <el-popover
                popper-class="popover-content"
                v-if="Array.isArray(LogDetail.belongStaffs)"
                placement="top-start"
                title="业务指派人员"
                width="700"
                trigger="hover"
                :open-delay="400"
                :content="getStaffName(LogDetail.belongStaffs)"
              >
                <span slot="reference" class="explain-content text-overflow">
                  {{ getStaffName(LogDetail.belongStaffs) }}
                </span>
              </el-popover>
            </el-col>
          </el-row>
        </div>
        
      
      </div>
      
    </div>
  </div>
</template>

<script>
import HospitalOption from './HospitalOption';
export default {
  components: {
    HospitalOption,
  },
  props: {
    LogDetail: {
      // 详情
      type: Object,
      default: {},
    },
    objectType: {
      // 客户类型
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fullscreenLoading: false,
    };
  },
  computed: {
    configName() {
      return this.$route.query.configName
    }
  },
  created() {},
  methods: {
    //获取配置下拉选项
    transform(list, val) {
      var name = '暂无等级';
      if (list && list.length > 0) {
        list.forEach((item) => {
          if (val == item.value) {
            name = item.text;
          }
        });
      }
      return name;
    },
    //获取配置对应字段
    getFieldConfig(params, key) {
      if (!localStorage.getItem(this.configName)) return;
      var fieldList = JSON.parse(localStorage.getItem(this.configName)).fieldList;
      var newConfig = {};
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return newConfig && newConfig[key];
    },
    getData() {
      let self = this;
      this.fullscreenLoading = true;
      let query = {
        tenantGuid: localStorage.guid,
        guid: self.$route.query.bizGuid,
      };
      self.api
        .get(
          `/${serverConfig.msCustomerService}/customer-history/detail/property-guid?propertyApprovalGuid=${self.$route.query.guid}`,
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.LogDetail = res.data.data ? res.data.data : {};
            if (!res.data.data) {
              self.$message.error('未获取到数据');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getStaffName(list) {
      let arr = Array.isArray(list) ? list.map((item) => `${item.staffName}-${item.mobileNo}`) : [];
      return arr.join('、');
    },
    // 终端选项参数
    getOption() {
      let option = {};
      let { LogDetail } = this;
      if (this.objectType === '1') {
        option.label = '药店名称：';
        option.typeName = '药店类型：';
        option.name = LogDetail.customerName;
        option.type = LogDetail.terminalProperty;
      } else if (this.objectType === '3') {
        option.label = '商业公司名称：';
        option.typeName = '商业公司类型：';
        option.name = LogDetail.franchiseeName;
        option.type = LogDetail.property;
      } else if (this.objectType === '4') {
        option.label = '医院名称：';
        option.typeName = '机构性质：';
        option.name = LogDetail.medName;
        option.type = LogDetail.medType; // 机构性质
        option.orgRank = LogDetail.orgRank; // 机构级次 字典:医院级别
        option.orgType = LogDetail.orgType; // 机构类别 字典:医院分类
        option.orgGrade = LogDetail.orgGrade; // 机构等级 字典:医院等次
      }
      return option;
    },
  },
};
</script>

<style lang="less" scoped>
/* 标题 */
.page-title-box {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #d9d9d9;
}
.page-back {
  width: 60px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
}
.page-title {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
/* 内容 */
.explain-contain {
  background: #fff;
  padding: 20px 20px 30px 60px;
  height: calc(100vh - 220px)
}
.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}
.explain-contain .sub-title {
  text-align: left;
  font-size: 16px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}
.sub-title {
  color: #212121;
  font-size: 16px;
}
.el-col-12{
  display: flex;
  margin-bottom: 15px;
}
.el-col-24{
  display: flex;
  margin-bottom: 15px;
}
.explain-item {
  line-height: 40px;
  display: flex;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  text-align: left;
  display: inline-block;
  /* line-height: 30px; */
}
</style>